var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("form", { ref: "formObservation" }, [
    _c("div", { staticClass: "emd-panel" }, [
      _c("div", { staticClass: "emd-panel__section" }, [
        _c("div", { staticClass: "emd-panel__block" }, [
          _c("div", { staticClass: "el-chunk" }, [
            _c("h2", { staticClass: "emd-text _color_default _type_caption" }, [
              _vm._v(" " + _vm._s(_vm.$t("title")) + " "),
            ]),
          ]),
        ]),
        _c("div", { staticClass: "emd-panel__block" }, [
          _c("div", { staticClass: "el-chunk" }, [
            _c("div", { staticClass: "emd-form-group" }, [
              _c(
                "label",
                { staticClass: "emd-label", attrs: { for: "observation" } },
                [_vm._v(_vm._s(_vm.$t("observation-text")))]
              ),
              _c("textarea", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.form.observation,
                    expression: "form.observation",
                  },
                ],
                staticClass: "emd-input",
                attrs: {
                  type: "text",
                  cols: "30",
                  rows: "4",
                  disabled: _vm.disabled,
                },
                domProps: { value: _vm.form.observation },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) return
                    _vm.$set(_vm.form, "observation", $event.target.value)
                  },
                },
              }),
            ]),
          ]),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }